module.exports = __webpack_public_path__ + "static/media/007.f6c90801.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/007.jpg
// module id = 304
// module chunks = 0